// config/firebase.js
import { initializeApp } from 'firebase/app';
import { getDatabase, ref, set, update, remove, push, onValue, get } from 'firebase/database';

const Config = {
  apiKey: "AIzaSyBL_koGFs8rwDf8-KPuVotPcwTPLaGK0v0",
  authDomain: "sugandhi-flowers.firebaseapp.com",
  databaseURL: "https://sugandhi-flowers-default-rtdb.firebaseio.com",
  projectId: "sugandhi-flowers",
  storageBucket: "sugandhi-flowers.firebasestorage.app",
  messagingSenderId: "50931072136",
  appId: "1:50931072136:web:b7e8f8632f87869ceb333d"
};

const app = initializeApp(Config);
export const database = getDatabase(app);

export const dbRef = (path) => ref(database, path);
export const dbSet = (path, data) => set(ref(database, path), data);
export const dbUpdate = (path, data) => update(ref(database, path), data);
export const dbRemove = (path) => remove(ref(database, path));
export const dbPush = (path, data) => push(ref(database, path), data);
export const dbGet = async (path) => {
  const snapshot = await get(ref(database, path));
  return snapshot.val();
};
export const dbOnValue = (path, callback) => onValue(ref(database, path), callback);



export const sanitizeFirebasePath = (str) => {
  if (!str) return 'anonymous_user';
  if (typeof str !== 'string') return 'anonymous_user';
  return str.replace(/[.#$[\]]/g, '_').replace(/@/g, '_');
};

export const cleanFirebaseData = (obj) => {
  if (!obj) return {};
  if (typeof obj !== 'object') return obj;
  
  const cleaned = {};
  for (const [key, value] of Object.entries(obj)) {
    if (key.startsWith('$')) continue;
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      cleaned[key] = cleanFirebaseData(value);
    } else if (Array.isArray(value)) {
      cleaned[key] = value.map(item => {
        if (item && typeof item === 'object') return cleanFirebaseData(item);
        return item;
      });
    } else {
      cleaned[key] = value;
    }
  }
  return cleaned;
};


export const getSafeUserId = (user) => {
  if (!user) return 'anonymous_user';
  const userId = user.$id || user.uid || user.id;
  if (userId && typeof userId === 'string') {
    return sanitizeFirebasePath(userId);
  }
  if (user.email && typeof user.email === 'string') {
    return sanitizeFirebasePath(user.email);
  }
  return 'anonymous_user';
};


export const getCategories = async () => {
  const snapshot = await get(ref(database, 'categories'));
  return snapshot.val();
};

export const addCategory = async (categoryData) => {
  const newCategoryRef = push(ref(database, 'categories'));
  await set(newCategoryRef, {
    ...categoryData,
    createdAt: new Date().toISOString()
  });
  return { id: newCategoryRef.key, ...categoryData };
};

export const updateCategory = async (categoryId, categoryData) => {
  await update(ref(database, `categories/${categoryId}`), categoryData);
};

export const deleteCategory = async (categoryId) => {
  const subcategories = await get(ref(database, `subcategories/${categoryId}`));
  if (subcategories.val()) {
    await remove(ref(database, `subcategories/${categoryId}`));
  }
  await remove(ref(database, `categories/${categoryId}`));
};

export const getSubcategories = async (categoryId) => {
  const snapshot = await get(ref(database, `subcategories/${categoryId}`));
  return snapshot.val();
};

export const addSubcategory = async (categoryId, subcategoryData) => {
  const newSubRef = push(ref(database, `subcategories/${categoryId}`));
  await set(newSubRef, {
    ...subcategoryData,
    categoryId,
    createdAt: new Date().toISOString()
  });
  return { id: newSubRef.key, ...subcategoryData };
};

export const updateSubcategory = async (categoryId, subcategoryId, subcategoryData) => {
  await update(ref(database, `subcategories/${categoryId}/${subcategoryId}`), subcategoryData);
};

export const deleteSubcategory = async (categoryId, subcategoryId) => {
  await remove(ref(database, `subcategories/${categoryId}/${subcategoryId}`));
};

export const onCategoriesChange = (callback) => {
  return onValue(ref(database, 'categories'), (snapshot) => {
    const data = snapshot.val();
    if (data) {
      const categoriesList = Object.entries(data).map(([id, cat]) => ({
        id,
        ...cat
      }));
      callback(categoriesList);
    } else {
      callback([]);
    }
  });
};

export const onSubcategoriesChange = (categoryId, callback) => {
  return onValue(ref(database, `subcategories/${categoryId}`), (snapshot) => {
    const data = snapshot.val();
    if (data) {
      const subcategoriesList = Object.entries(data).map(([id, sub]) => ({
        id,
        ...sub
      }));
      callback(subcategoriesList);
    } else {
      callback([]);
    }
  });
};